<div class="customize-fields__inner-container">
  <field-type-list-simple [field]="customizeFieldOther.fieldInfoOrigin"
    [listValues]="customizeFieldOther.fieldOriginList"
    [preSelectItem]="customizeFieldOther.field.relatedConceptId"
    (itemSelected)="fieldChangeSelect($event)">
  </field-type-list-simple>
  <field-type-list-simple [field]="customizeFieldOther.fieldInfoSelect"
    [listValues]="customizeFieldOther.fieldSelectList"
    [preSelectItem]="customizeFieldOther.fieldPreselect"
    (itemSelected)="fieldConceptSelect($event.newValue)">
  </field-type-list-simple>
  <field-type-list-multiple [field]="customizeFieldOther.fieldInfoAdditional"
    [listValues]="customizeFieldOther.additionalFieldsSelectList"
    [preSelectItem]="customizeFieldOther.additionalPreselect"
    (itemSelected)="additionalField($event)">
  </field-type-list-multiple>
  <div class="customize-fields-switch-form__container">
    <customize-fields-switch-form
      [field]="customizeFieldOther.field"
      [small]="true"
      [concept]="concept"
      [isPrivate]="isPrivate"
      [hiddenInLandings]="hiddenInLandings"
      [previewMode]="previewMode"></customize-fields-switch-form>
    <field-type-switch
      [field]="customizeFieldOther.multipleField"
      [small]="true"
      [preSelectItem]="customizeFieldOther.field.multiple"
      [disabled]="customizeFieldOther.field.noEditable || previewMode"
      (itemSelected)="itemSelected($event, 'multiple')">
    </field-type-switch>
    @if(customizeFieldOther.field.multiple){
      <field-type-switch
        [field]="customizeFieldOther.ungrupedViewField"
        [small]="true"
        [preSelectItem]="customizeFieldOther.field.lcoIsUngroupedView"
        [disabled]="customizeFieldOther.field.noEditable || previewMode"
        (itemSelected)="itemSelected($event, 'lcoIsUngroupedView')">
      </field-type-switch>
    }
  </div>
</div>
